import React, { useState, useEffect } from 'react';
import './Footer.scss';
import { useTranslation } from 'react-i18next';
import { Config } from '../../models';
import { decodeBase64Html } from '../../utils';

const MOBILE_MAX_WIDTH = 1024;

export const Footer = React.memo(
  ({ config }: { config: Config }): JSX.Element => {
    const { t } = useTranslation();
    const [isMobile, setIsMobile] = useState(
      window.innerWidth < MOBILE_MAX_WIDTH,
    );

    useEffect(() => {
      const handleResize = (): void => {
        setIsMobile(window.innerWidth < MOBILE_MAX_WIDTH);
      };

      window.addEventListener('resize', handleResize);
      handleResize(); // Initial check

      return () => window.removeEventListener('resize', handleResize);
    }, []);

    const isFooterHtml = !!config.appConfig.isFooterHtml;
    const rawFooterHtml: string = config.uiConfig.customHtml?.footerHtml ?? '';
    const isFooterUrl =
      isFooterHtml && /^https?:\/\//i.test(rawFooterHtml.trim());

    const [fetchedFooterHtml, setFetchedFooterHtml] = useState<string>('');

    useEffect(() => {
      if (!isFooterUrl) {
        return;
      }

      fetch(rawFooterHtml)
        .then((res) => (res.ok ? res.text() : ''))
        .then((html) => {
          setFetchedFooterHtml(html);
        })
        .catch(() => {
          setFetchedFooterHtml('');
        });
    }, [isFooterUrl, rawFooterHtml]);

    if (isFooterHtml) {
      const footerHtml = isFooterUrl
        ? fetchedFooterHtml
        : decodeBase64Html(rawFooterHtml);

      return (
        <footer
          dangerouslySetInnerHTML={{
            __html: footerHtml,
          }}
        ></footer>
      );
    }

    const footerText =
      config.appConfig.hasMobileFooter && isMobile
        ? 'mobileFooterText'
        : 'footerText';

    return (
      <footer
        className="footer"
        dangerouslySetInnerHTML={{ __html: t(footerText) }}
      ></footer>
    );
  },
);
